// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fundSelector_Company {\n  width: -webkit-fill-available !important;\n}\n#rankingTab .el-tabs__item {\n  color: #606266;\n}\n#rankingTab .el-tabs__item.is-active, #rankingTab .el-tabs__item:hover {\n  color: #EF7621;\n}\n#rankingTab .el-tabs__active-bar {\n  background-color: #EF7621;\n}\n#rankingTab .el-tabs__header {\n  margin-bottom: 0px !important;\n  line-height: 48px;\n}\n#rankingTab .el-tabs__content .el-tabs__nav-scroll {\n  background-color: #F8F8F8 !important;\n  line-height: 48px;\n}\n#rankingTab .el-tabs__content div i {\n  color: #EF7621;\n  font-size: 18px;\n  line-height: 48px;\n}\n#subRankingTab .el-tabs__item {\n  color: #606266;\n}\n#subRankingTab .el-tabs__item.is-active, #subRankingTab .el-tabs__item:hover {\n  color: #676767;\n  font-weight: bold;\n}\n#subRankingTab .el-tabs__active-bar {\n  background-color: transparent;\n}\n#tab-1,\n#tab-2,\n#tab-3,\n#tab-4,\n#tab-5,\n#tab-6,\n#tab-7,\n#tab-8,\n#tab-9,\n#tab-10,\n#tab-11,\n#tab-12,\n#tab-13,\n#tab-14,\n#tab-15,\n#tab-16,\n#tab-17,\n#tab-18,\n#tab-19 {\n  padding: 0px;\n}\n.ranking-search-return {\n  line-height: 14px;\n  font-size: 16px;\n  text-align: center;\n  margin-left: 22px;\n}\n.ranking-search-return-font-color {\n  color: rgb(25, 137, 250);\n  cursor: pointer;\n}\n.suitability_home_title {\n  height: 67px;\n  color: rgb(48, 49, 51) !important;\n  font-size: 40px !important;\n}\n.ranking-exportExcel {\n  padding: 0px !important;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fundSelector_Company": "fundSelector_Company",
	"rankingTab": "rankingTab",
	"el-tabs__item": "el-tabs__item",
	"is-active": "is-active",
	"el-tabs__active-bar": "el-tabs__active-bar",
	"el-tabs__header": "el-tabs__header",
	"el-tabs__content": "el-tabs__content",
	"el-tabs__nav-scroll": "el-tabs__nav-scroll",
	"subRankingTab": "subRankingTab",
	"tab-1": "tab-1",
	"tab-2": "tab-2",
	"tab-3": "tab-3",
	"tab-4": "tab-4",
	"tab-5": "tab-5",
	"tab-6": "tab-6",
	"tab-7": "tab-7",
	"tab-8": "tab-8",
	"tab-9": "tab-9",
	"tab-10": "tab-10",
	"tab-11": "tab-11",
	"tab-12": "tab-12",
	"tab-13": "tab-13",
	"tab-14": "tab-14",
	"tab-15": "tab-15",
	"tab-16": "tab-16",
	"tab-17": "tab-17",
	"tab-18": "tab-18",
	"tab-19": "tab-19",
	"ranking-search-return": "ranking-search-return",
	"ranking-search-return-font-color": "ranking-search-return-font-color",
	"suitability_home_title": "suitability_home_title",
	"ranking-exportExcel": "ranking-exportExcel"
};
module.exports = ___CSS_LOADER_EXPORT___;
